<script>
export default {
  props: {
    action: {}
  },

  computed: {
    label() {
      if (!this.action) {
        return 'Not yet started'
      }
      if (this.action.isLoading) { return 'Running' }
      if (this.action.error) { return 'Error' }
      return 'Finished'
    },

    statusType() {
      if (this.action) {
        if (this.action.error) { return 'is-danger' }
        if (this.action.isLoading){ return 'is-primary' }
        return 'is-success'
      }
      return 'is-info'
    }
  }
}
</script>

<template>
  <b-taglist attached>
    <b-tag type="is-grey">Status</b-tag>
    <b-tag :type="statusType">{{ label }}</b-tag>
  </b-taglist>
</template>

<style lang="scss">
</style>